import React, { FC } from "react";
import DateTimeSetting from "./DateTimeSetting";

const General: FC = () => {
  return (
    <>
      <DateTimeSetting />
    </>
  );
};

export default General;
